import { Lightbulb, GraduationCap } from "lucide-react";

export function Links() {
  return (
    <div className="w-full rounded-lg border-zinc-200/30 shadow-md border p-4 gap-2 flex flex-col sm:col-span-1 sm:row-span-2 md:col-span-1 md:row-span-3 lg:col-span-2 lg:row-span-2 xl:col-span-4 xl:row-span-3 bg-white">
      <div className="w-full flex">
        <span className="flex gap-2 text-scale-500 font-semibold text-lg items-center">
          <Lightbulb />Links Úteis
        </span>
      </div>
      <div className="w-full flex-wrap flex gap-y-2 gap-x-4 mt-auto">
        <a href="https://petland.sults.com.br/universidade/aluno/curso/163/0" target="_blank" rel="noreferrer" className="flex gap-1 text-zinc-500 group hover:text-scale-500 items-center">
          <GraduationCap className="text-scale-500 w-5 h-5" /><span className="border-b border-white group-hover:border-scale-500">Treinamentos</span>
        </a>
      </div>
    </div>
  );
}
